import { AnyAction } from "redux";
import { put, retry, takeLatest } from "redux-saga/effects";
import {
  FETCH_EXIT_SURVEY_DEVICE_DISTRIBUTION,
  FETCH_EXIT_SURVEY_FEEDBACK,
  FETCH_EXIT_SURVEY_NON_COMPLETION_REASONS,
  FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION,
  FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION_BY_MARKET,
  FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION_SELECTED_MARKETS,
  FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION_TREND,
  FETCH_FEEDBACK_COMMENTS,
  FETCH_FEEDBACK_COMMENTS_FILTERS,
  FETCH_MARKET_OVERVIEW,
  FETCH_RATING_PER_TOUCHPOINT_COMPLETION_RATE,
  FETCH_RATING_PER_TOUCHPOINT_EDITORIAL,
  FETCH_RATING_PER_TOUCHPOINT_ELECTRIFICATION,
  FETCH_RATING_PER_TOUCHPOINT_MARKET_BREAKDOWN,
  FETCH_RATING_PER_TOUCHPOINT_MEDIA_CAMPAIGNS,
  FETCH_RATING_PER_TOUCHPOINT_OTHER_TOUCHPOINTS,
  FETCH_RATING_PER_TOUCHPOINT_OWNERSHIP,
  FETCH_RATING_PER_TOUCHPOINT_VLP_FOCUS,
  FETCH_STAR_RATING_AVERAGE_RATING,
  FETCH_STAR_RATING_AVERAGE_RATING_BY_MARKET,
  FETCH_STAR_RATING_AVERAGE_RATING_SELECTED_MARKETS,
  FETCH_STAR_RATING_AVERAGE_RATING_TREND,
  FETCH_STAR_RATING_DEVICE_DISTRIBUTION,
  FETCH_STAR_RATING_FEEDBACK,
  FETCH_STAR_RATING_SCORE_DISTRIBUTION,
  FETCH_TOPIC_CLASSIFICATION_DISSATISFACTION,
  FETCH_TOPIC_CLASSIFICATION_SATISFACTION,
  FETCH_VOC_AFTER_SALES_TOPIC_CLASSIFICATION_SATISFACTION,
  FETCH_VOC_AFTER_SALES_TOPIC_CLASSIFICATION_DISSATISFACTION,
  FETCH_VOC_QUICK_SALES_FEEDBACK_COMMENTS,
  FETCH_VOC_QUICK_SALES_TOPIC_CLASSIFICATION_DISSATISFACTION,
  FETCH_VOC_QUICK_SALES_TOPIC_CLASSIFICATION_SATISFACTION,
  FETCH_VOC_AFTER_SALES_FEEDBACK_COMMENTS,
  FETCH_VOC_QUICK_SALES_FEEDBACK_COMMENTS_FILTERS,
  FETCH_VOC_AFTER_SALES_FEEDBACK_COMMENTS_FILTERS,
} from "../actions/actionTypes/vocActionTypes";
import { setLoading } from "../actions/loadingActions";
import {
  setExitSurveyDeviceDistribution,
  setExitSurveyFeedback,
  setExitSurveyNonCompletionReasons,
  setExitSurveyObjectiveCompletion,
  setExitSurveyObjectiveCompletionByMarket,
  setExitSurveyObjectiveCompletionSelectedMarkets,
  setExitSurveyObjectiveCompletionTrend,
  setFeedbackComments,
  setFeedbackCommentsFilters,
  setMarketOverview,
  setRatingPerTouchpointCompletionRate,
  setRatingPerTouchPointEditorial,
  setRatingPerTouchpointElectrification,
  setRatingPerTouchpointMarketBreakdown,
  setRatingPerTouchpointMediaCampaigns,
  setRatingPerTouchpointOtherTouchpoints,
  setRatingPerTouchPointOwnership,
  setRatingPerTouchpointVlpFocus,
  setStarRatingAverageRating,
  setStarRatingAverageRatingByMarket,
  setStarRatingAverageRatingSelectedMarkets,
  setStarRatingAverageRatingTrend,
  setStarRatingDeviceDistribution,
  setStarRatingFeedback,
  setStarRatingScoreDistribution,
  setTopicClassificationDissatisfaction,
  setTopicClassificationSatisfaction,
  setVocAfterSalesFeedbackComments,
  setVocAfterSalesFeedbackCommentsFilters,
  setVocAfterSalesTopicClassificationDissatisfaction,
  setVocAfterSalesTopicClassificationSatisfaction,
  setVocQuickSalesFeedbackComments,
  setVocQuickSalesFeedbackCommentsFilters,
  setVocQuickSalesTopicClassificationDissatisfaction,
  setVocQuickSalesTopicClassificationSatisfaction,
} from "../actions/vocActions";
import { secondsDelay } from "../api/utils";
import {
  getExitSurveyDeviceDistribution,
  getExitSurveyFeedback,
  getExitSurveyNonCompletionReasons,
  getExitSurveyObjectiveCompletion,
  getExitSurveyObjectiveCompletionByMarket,
  getExitSurveyObjectiveCompletionSelectedMarkets,
  getExitSurveyObjectiveCompletionTrend,
  getFeedbackComments,
  getFeedbackCommentsFilters,
  getMarketOverview,
  getRatingPerTouchpointCompletionRate,
  getRatingPerTouchpointElectrification,
  getRatingPerTouchpointMarketBreakdown,
  getRatingPerTouchpointMediaCampaigns,
  getRatingPerTouchpointOtherTouchpoints,
  getRatingPerTouchpointVlpFocus,
  getRptEditorial,
  getRptOwnership,
  getStarRatingAverageRating,
  getStarRatingAverageRatingByMarket,
  getStarRatingAverageRatingSelectedMarkets,
  getStarRatingAverageRatingTrend,
  getStarRatingDeviceDistribution,
  getStarRatingFeedback,
  getStarRatingScoreDistribution,
  getTopicClassificationDissatisfaction,
  getTopicClassificationSatisfaction,
} from "../api/vocApi";
import { getVocQuickSalesFeedbackComments, getVocQuickSalesFeedbackCommentsFilters, getVocQuickSalesTopicClassificationDissatisfaction, getVocQuickSalesTopicClassificationSatisfaction } from "../api/quickVocSalesApi";
import { getVocAfterSalesTopicClassificationDissatisfaction, getVocAfterSalesTopicClassificationSatisfaction, getVocAfterSalesFeedbackComments, getVocAfterSalesFeedbackCommentsFilters } from "../api/quickVocAfterSales";

// Watcher sagas
export function* watchFetchMarketOverviewSaga() {
  yield takeLatest(FETCH_MARKET_OVERVIEW, fetchMarketOverview);
}

export function* watchFetchStarRatingAverageRatingSaga() {
  yield takeLatest(FETCH_STAR_RATING_AVERAGE_RATING, fetchStarRatingAverageRating);
}

export function* watchFetchStarRatingAverageRatingTrendSaga() {
  yield takeLatest(FETCH_STAR_RATING_AVERAGE_RATING_TREND, fetchStarRatingAverageRatingTrend);
}

export function* watchFetchStarRatingFeedbackSaga() {
  yield takeLatest(FETCH_STAR_RATING_FEEDBACK, fetchStarRatingFeedback);
}

export function* watchFetchStarRatingScoreDistributionSaga() {
  yield takeLatest(FETCH_STAR_RATING_SCORE_DISTRIBUTION, fetchStarRatingScoreDistribution);
}

export function* watchFetchStarRatingDeviceDistributionSaga() {
  yield takeLatest(FETCH_STAR_RATING_DEVICE_DISTRIBUTION, fetchStarRatingDeviceDistribution);
}

export function* watchFetchStarRatingAverageRatingByMarketSaga() {
  yield takeLatest(FETCH_STAR_RATING_AVERAGE_RATING_BY_MARKET, fetchStarRatingAverageRatingByMarket);
}

export function* watchFetchStarRatingAverageRatingSelectedMarketsSaga() {
  yield takeLatest(FETCH_STAR_RATING_AVERAGE_RATING_SELECTED_MARKETS, fetchStarRatingAverageRatingSelectedMarkets);
}

export function* watchFetchExitSurveyObjectiveCompletionSaga() {
  yield takeLatest(FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION, fetchExitSurveyObjectiveCompletion);
}

export function* watchFetchExitSurveyFeedbackSaga() {
  yield takeLatest(FETCH_EXIT_SURVEY_FEEDBACK, fetchExitSurveyFeedback);
}

export function* watchFetchExitSurveyObjectiveCompletionTrendSaga() {
  yield takeLatest(FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION_TREND, fetchExitSurveyObjectiveCompletionTrend);
}

export function* watchFetchExitSurveyNonCompletionReasonsSaga() {
  yield takeLatest(FETCH_EXIT_SURVEY_NON_COMPLETION_REASONS, fetchExitSurveyNonCompletionReasons);
}

export function* watchFetchExitSurveyDeviceDistributionSaga() {
  yield takeLatest(FETCH_EXIT_SURVEY_DEVICE_DISTRIBUTION, fetchExitSurveyDeviceDistribution);
}

export function* watchFetchExitSurveyObjectiveCompletionByMarketSaga() {
  yield takeLatest(FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION_BY_MARKET, fetchExitSurveyObjectiveCompletionByMarket);
}

export function* watchFetchExitSurveyObjectiveCompletionSelectedMarketsSaga() {
  yield takeLatest(FETCH_EXIT_SURVEY_OBJECTIVE_COMPLETION_SELECTED_MARKETS, fetchExitSurveyObjectiveCompletionSelectedMarkets);
}

export function* watchFetchRatingPerTouchpointMarketBreakdownSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_MARKET_BREAKDOWN, fetchRatingPerTouchpointMarketBreakdown);
}

export function* watchFetchRatingPerTouchpointVlpFocusSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_VLP_FOCUS, fetchRatingPerTouchpointVlpFocus);
}

export function* watchFetchRatingPerTouchpointElectrificationSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_ELECTRIFICATION, fetchRatingPerTouchpointElectrification);
}

export function* watchFetchRatingPerTouchpointOtherTouchpointsSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_OTHER_TOUCHPOINTS, fetchRatingPerTouchpointOtherTouchpoints);
}

export function* watchFetchRatingPerTouchpointMediaCampaignsSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_MEDIA_CAMPAIGNS, fetchRatingPerTouchpointMediaCampaigns);
}

export function* watchFetchRatingPerTouchpointCompletionRateSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_COMPLETION_RATE, fetchRatingPerTouchpointCompletionRate);
}

export function* watchFetchTopicClassificationDissatisfactionSaga() {
  yield takeLatest(FETCH_TOPIC_CLASSIFICATION_DISSATISFACTION, fetchTopicClassificationDissatisfaction);
}

export function* watchFetchTopicClassificationSatisfactionSaga() {
  yield takeLatest(FETCH_TOPIC_CLASSIFICATION_SATISFACTION, fetchTopicClassificationSatisfaction);
}

export function* watchFetchFeedbackCommentsSaga() {
  yield takeLatest(FETCH_FEEDBACK_COMMENTS, fetchFeedbackComments);
}

export function* watchFetchVocQuickSalesTopicClassificationDissatisfactionSaga() {
  yield takeLatest(FETCH_VOC_QUICK_SALES_TOPIC_CLASSIFICATION_DISSATISFACTION, fetchVocQuickSalesTopicClassificationDissatisfaction);
}

export function* watchFetchVocQuickSalesTopicClassificationSatisfactionSaga() {
  yield takeLatest(FETCH_VOC_QUICK_SALES_TOPIC_CLASSIFICATION_SATISFACTION, fetchVocQuickSalesTopicClassificationSatisfaction);
}

export function* watchFetchVocQuickSalesFeedbackCommentsSaga() {
  yield takeLatest(FETCH_VOC_QUICK_SALES_FEEDBACK_COMMENTS, fetchVocQuickSalesFeedbackComments);
}

export function* watchFetchVocAfterSalesTopicClassificationDissatisfactionSaga() {
  yield takeLatest(FETCH_VOC_AFTER_SALES_TOPIC_CLASSIFICATION_DISSATISFACTION, fetchVocAfterSalesTopicClassificationDissatisfaction);
}

export function* watchFetchVocAfterSalesTopicClassificationSatisfactionSaga() {
  yield takeLatest(FETCH_VOC_AFTER_SALES_TOPIC_CLASSIFICATION_SATISFACTION, fetchVocAfterSalesTopicClassificationSatisfaction);
}

export function* watchFetchVocAfterSalesFeedbackCommentsSaga() {
  yield takeLatest(FETCH_VOC_AFTER_SALES_FEEDBACK_COMMENTS, fetchVocAfterSalesFeedbackComments);
}

export function* watchFetchRptOwnershipSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_OWNERSHIP, fetchRptOwnership);
}

export function* watchFetchRptEditorialSaga() {
  yield takeLatest(FETCH_RATING_PER_TOUCHPOINT_EDITORIAL, fetchRptEditorial);
}

export function* watchFetchFeedbackCommentsFiltersSaga() {
  yield takeLatest(FETCH_FEEDBACK_COMMENTS_FILTERS, fetchFeedbackCommentsFilters);
}

export function* watchFetchVocQuickSalesFeedbackCommentsFiltersSaga() {
  yield takeLatest(FETCH_VOC_QUICK_SALES_FEEDBACK_COMMENTS_FILTERS, fetchVocQuickSalesFeedbackCommentsFilters);
}

export function* watchFetchVocAfterSalesFeedbackCommentsFiltersSaga() {
  yield takeLatest(FETCH_VOC_AFTER_SALES_FEEDBACK_COMMENTS_FILTERS, fetchVocAfterSalesFeedbackCommentsFilters);
}

// Worker sagas
export function* fetchMarketOverview() {
  try {
    yield put(setLoading("market_overview", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getMarketOverview);
    if (!("error" in response)) {
      yield put(setMarketOverview(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/market_overview");
  } finally {
    yield put(setLoading("market_overview", false));
  }
}

export function* fetchStarRatingAverageRating() {
  try {
    yield put(setLoading("star_rating_average_rating", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getStarRatingAverageRating);
    if (!("error" in response)) {
      yield put(setStarRatingAverageRating(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/star-rating-overview/average-rating");
  } finally {
    yield put(setLoading("star_rating_average_rating", false));
  }
}

export function* fetchStarRatingAverageRatingTrend() {
  try {
    yield put(setLoading("star_rating_average_rating_trend", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getStarRatingAverageRatingTrend);
    if (!("error" in response)) {
      yield put(setStarRatingAverageRatingTrend(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/star-rating-overview/average-rating-trend");
  } finally {
    yield put(setLoading("star_rating_average_rating_trend", false));
  }
}

export function* fetchStarRatingFeedback() {
  try {
    yield put(setLoading("star_rating_feedback", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getStarRatingFeedback);
    if (!("error" in response)) {
      yield put(setStarRatingFeedback(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/star-rating-overview/feedback");
  } finally {
    yield put(setLoading("star_rating_feedback", false));
  }
}

export function* fetchStarRatingScoreDistribution() {
  try {
    yield put(setLoading("star_rating_score_distribution", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getStarRatingScoreDistribution);
    if (!("error" in response)) {
      yield put(setStarRatingScoreDistribution(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/star-rating-overview/score-distribution");
  } finally {
    yield put(setLoading("star_rating_score_distribution", false));
  }
}

export function* fetchStarRatingDeviceDistribution() {
  try {
    yield put(setLoading("star_rating_device_distribution", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getStarRatingDeviceDistribution);
    if (!("error" in response)) {
      yield put(setStarRatingDeviceDistribution(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/star-rating-overview/device-distribution");
  } finally {
    yield put(setLoading("star_rating_device_distribution", false));
  }
}

export function* fetchStarRatingAverageRatingByMarket({ payload: markets }: AnyAction) {
  try {
    yield put(setLoading("star_rating_average_rating_by_market", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getStarRatingAverageRatingByMarket, markets);
    if (!("error" in response)) {
      yield put(setStarRatingAverageRatingByMarket(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/star-rating-overview/average-rating-by-market");
  } finally {
    yield put(setLoading("star_rating_average_rating_by_market", false));
  }
}

export function* fetchStarRatingAverageRatingSelectedMarkets({ payload: markets }: AnyAction) {
  try {
    yield put(setLoading("star_rating_average_rating_selected_markets", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getStarRatingAverageRatingSelectedMarkets, markets);
    if (!("error" in response)) {
      yield put(setStarRatingAverageRatingSelectedMarkets(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/star-rating-overview/average-rating");
  } finally {
    yield put(setLoading("star_rating_average_rating_selected_markets", false));
  }
}

export function* fetchExitSurveyObjectiveCompletion() {
  try {
    yield put(setLoading("exit_survey_objective_completion", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getExitSurveyObjectiveCompletion);
    if (!("error" in response)) {
      yield put(setExitSurveyObjectiveCompletion(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/exit-survey/objective-completion");
  } finally {
    yield put(setLoading("exit_survey_objective_completion", false));
  }
}

export function* fetchExitSurveyFeedback() {
  try {
    yield put(setLoading("exit_survey_feedback", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getExitSurveyFeedback);
    if (!("error" in response)) {
      yield put(setExitSurveyFeedback(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/exit-survey/feedback");
  } finally {
    yield put(setLoading("exit_survey_feedback", false));
  }
}

export function* fetchExitSurveyObjectiveCompletionTrend() {
  try {
    yield put(setLoading("exit_survey_objective_completion_trend", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getExitSurveyObjectiveCompletionTrend);
    if (!("error" in response)) {
      yield put(setExitSurveyObjectiveCompletionTrend(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/exit-survey/objective-completion-trend");
  } finally {
    yield put(setLoading("exit_survey_objective_completion_trend", false));
  }
}

export function* fetchExitSurveyNonCompletionReasons() {
  try {
    yield put(setLoading("exit_survey_objective_non_completion_reasons", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getExitSurveyNonCompletionReasons);
    if (!("error" in response)) {
      yield put(setExitSurveyNonCompletionReasons(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/exit-survey/non-completion-reasons");
  } finally {
    yield put(setLoading("exit_survey_objective_non_completion_reasons", false));
  }
}

export function* fetchExitSurveyDeviceDistribution() {
  try {
    yield put(setLoading("exit_survey_device_distribution", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getExitSurveyDeviceDistribution);
    if (!("error" in response)) {
      yield put(setExitSurveyDeviceDistribution(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/exit-survey/device-distribution");
  } finally {
    yield put(setLoading("exit_survey_device_distribution", false));
  }
}

export function* fetchExitSurveyObjectiveCompletionByMarket({ payload: markets }: AnyAction) {
  try {
    yield put(setLoading("exit_survey_objective_completion_by_market", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getExitSurveyObjectiveCompletionByMarket, markets);
    if (!("error" in response)) {
      yield put(setExitSurveyObjectiveCompletionByMarket(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/exit-survey/objective-completion-by-market");
  } finally {
    yield put(setLoading("exit_survey_objective_completion_by_market", false));
  }
}

export function* fetchExitSurveyObjectiveCompletionSelectedMarkets({ payload: markets }: AnyAction) {
  try {
    yield put(setLoading("exit_survey_objective_completion_selected_markets", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getExitSurveyObjectiveCompletionSelectedMarkets, markets);
    if (!("error" in response)) {
      yield put(setExitSurveyObjectiveCompletionSelectedMarkets(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/exit-survey/objective-completion");
  } finally {
    yield put(setLoading("exit_survey_objective_completion_selected_markets", false));
  }
}

export function* fetchRatingPerTouchpointMarketBreakdown() {
  try {
    yield put(setLoading("rating_per_touchpoint_market_breakdown", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getRatingPerTouchpointMarketBreakdown);
    if (!("error" in response)) {
      yield put(setRatingPerTouchpointMarketBreakdown(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/rating-per-touchpoint/market-breakdown");
  } finally {
    yield put(setLoading("rating_per_touchpoint_market_breakdown", false));
  }
}

export function* fetchRatingPerTouchpointVlpFocus() {
  try {
    yield put(setLoading("rating_per_touchpoint_vlp_focus", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getRatingPerTouchpointVlpFocus);
    if (!("error" in response)) {
      yield put(setRatingPerTouchpointVlpFocus(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/rating-per-touchpoint/vlp-focus");
  } finally {
    yield put(setLoading("rating_per_touchpoint_vlp_focus", false));
  }
}

export function* fetchRatingPerTouchpointElectrification() {
  try {
    yield put(setLoading("rating_per_touchpoint_electrification", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getRatingPerTouchpointElectrification);
    if (!("error" in response)) {
      yield put(setRatingPerTouchpointElectrification(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/rating-per-touchpoint/electrification");
  } finally {
    yield put(setLoading("rating_per_touchpoint_electrification", false));
  }
}

export function* fetchRatingPerTouchpointOtherTouchpoints() {
  try {
    yield put(setLoading("rating_per_touchpoint_other_touchpoints", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getRatingPerTouchpointOtherTouchpoints);
    if (!("error" in response)) {
      yield put(setRatingPerTouchpointOtherTouchpoints(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/rating-per-touchpoint/other-touchpoints");
  } finally {
    yield put(setLoading("rating_per_touchpoint_other_touchpoints", false));
  }
}

export function* fetchRatingPerTouchpointMediaCampaigns() {
  try {
    yield put(setLoading("rating_per_touchpoint_media_campaigns", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getRatingPerTouchpointMediaCampaigns);
    if (!("error" in response)) {
      yield put(setRatingPerTouchpointMediaCampaigns(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/rating-per-touchpoint/media-campaigns");
  } finally {
    yield put(setLoading("rating_per_touchpoint_media_campaigns", false));
  }
}

export function* fetchRatingPerTouchpointCompletionRate() {
  try {
    yield put(setLoading("rating_per_touchpoint_completion_rate", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getRatingPerTouchpointCompletionRate);
    if (!("error" in response)) {
      yield put(setRatingPerTouchpointCompletionRate(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/rating-per-touchpoint/completion-rate");
  } finally {
    yield put(setLoading("rating_per_touchpoint_completion_rate", false));
  }
}

export function* fetchTopicClassificationDissatisfaction() {
  try {
    yield put(setLoading("topic_classification_dissatisfaction", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getTopicClassificationDissatisfaction);
    if (!("error" in response)) {
      yield put(setTopicClassificationDissatisfaction(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/topic-classification-dissatisfaction");
  } finally {
    yield put(setLoading("topic_classification_dissatisfaction", false));
  }
}

export function* fetchTopicClassificationSatisfaction() {
  try {
    yield put(setLoading("topic_classification_satisfaction", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getTopicClassificationSatisfaction);
    if (!("error" in response)) {
      yield put(setTopicClassificationSatisfaction(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/topic-classification-satisfaction");
  } finally {
    yield put(setLoading("topic_classification_satisfaction", false));
  }
}

export function* fetchFeedbackComments({ experience_rating, topics, touchpoints }: AnyAction) {
  try {
    yield put(setLoading("feedback_comments", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getFeedbackComments, experience_rating, topics, touchpoints);
    if (!("error" in response)) {
      yield put(setFeedbackComments(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/categories/feedback-comments");
  } finally {
    yield put(setLoading("feedback_comments", false));
  }
}


export function* fetchVocQuickSalesTopicClassificationDissatisfaction() {
  try {
    yield put(setLoading("voc_quick_sales_topic_classification_dissatisfaction", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocQuickSalesTopicClassificationDissatisfaction);
    if (!("error" in response)) {
      yield put(setVocQuickSalesTopicClassificationDissatisfaction(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/voc-quick-sales/topic-classification-dissatisfaction");
  } finally {
    yield put(setLoading("voc_quick_sales_topic_classification_dissatisfaction", false));
  }
}

export function* fetchVocQuickSalesTopicClassificationSatisfaction() {
  try {
    yield put(setLoading("voc_quick_sales_topic_classification_satisfaction", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocQuickSalesTopicClassificationSatisfaction);
    if (!("error" in response)) {
      yield put(setVocQuickSalesTopicClassificationSatisfaction(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/voc-quick-sales/topic-classification-satisfaction");
  } finally {
    yield put(setLoading("voc_quick_sales_topic_classification_satisfaction", false));
  }
}

export function* fetchVocQuickSalesFeedbackComments({ google_rating, topics, touchpoints }: AnyAction) {
  try {
    yield put(setLoading("voc_quick_sales_feedback_comments", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocQuickSalesFeedbackComments, google_rating, topics, touchpoints);
    if (!("error" in response)) {
      yield put(setVocQuickSalesFeedbackComments(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/categories/feedback-comments");
  } finally {
    yield put(setLoading("voc_quick_sales_feedback_comments", false));
  }
}


export function* fetchVocAfterSalesTopicClassificationDissatisfaction() {
  try {
    yield put(setLoading("voc_after_sales_topic_classification_dissatisfaction", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocAfterSalesTopicClassificationDissatisfaction);
    if (!("error" in response)) {
      yield put(setVocAfterSalesTopicClassificationDissatisfaction(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/voc-after-sales/topic-classification-dissatisfaction");
  } finally {
    yield put(setLoading("voc_after_sales_topic_classification_dissatisfaction", false));
  }
}

export function* fetchVocAfterSalesTopicClassificationSatisfaction() {
  try {
    yield put(setLoading("voc_after_sales_topic_classification_satisfaction", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocAfterSalesTopicClassificationSatisfaction);
    if (!("error" in response)) {
      yield put(setVocAfterSalesTopicClassificationSatisfaction(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/voc-after-sales/topic-classification-satisfaction");
  } finally {
    yield put(setLoading("voc_after_sales_topic_classification_satisfaction", false));
  }
}

export function* fetchVocAfterSalesFeedbackComments({ google_rating, topics, touchpoints }: AnyAction) {
  try {
    yield put(setLoading("voc_after_sales_feedback_comments", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocAfterSalesFeedbackComments, google_rating, topics, touchpoints);
    if (!("error" in response)) {
      yield put(setVocAfterSalesFeedbackComments(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/voc-after-sales/feedback-comments");
  } finally {
    yield put(setLoading("voc_after_sales_feedback_comments", false));
  }
}


export function* fetchRptOwnership() {
  try {
    yield put(setLoading("rpt_ownership", true));
    const response: Record<string, string> = yield retry(4, secondsDelay, getRptOwnership);
    if (!("error" in response)) {
      yield put(setRatingPerTouchPointOwnership(response));
    }
  } catch (err) {
    console.log("failed to fetch /voc/get_rpt_ownership_data_voc_rating_per_touchpoint_ownership_post");
  } finally {
    yield put(setLoading("rpt_ownership", false));
  }
}

export function* fetchRptEditorial() {
  try {
    yield put(setLoading("rpt_editorial", true));
    const response: Record<string, string> = yield retry(4, secondsDelay, getRptEditorial);
    if (!("error" in response)) {
      yield put(setRatingPerTouchPointEditorial(response));
    }
  } catch (err) {
    console.log("failed to fetch /voc/get_rpt_editorial_data_voc_rating_per_touchpoint_editorial_post");
  } finally {
    yield put(setLoading("rpt_editorial", false));
  }
}

export function* fetchFeedbackCommentsFilters() {
  try {
    yield put(setLoading("feedback_comments_filters", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getFeedbackCommentsFilters);
    if (!("error" in response)) {
      yield put(setFeedbackCommentsFilters(response));
    }
  } catch (err) {
    console.log("failed to fetch voc/categories/feedback-comments-filters");
  } finally {
    yield put(setLoading("feedback_comments_filters", false));
  }
}


export function* fetchVocQuickSalesFeedbackCommentsFilters() {
  try {
    yield put(setLoading("voc_quick_sales_feedback_comments_filters", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocQuickSalesFeedbackCommentsFilters);
    if (!("error" in response)) {
      yield put(setVocQuickSalesFeedbackCommentsFilters(response));
    }
  } catch (err) {
    console.log("failed to fetch voc-quick_sales/categories/feedback-comments-filters");
  } finally {
    yield put(setLoading("voc_quick_sales_feedback_comments_filters", false));
  }
}


export function* fetchVocAfterSalesFeedbackCommentsFilters() {
  try {
    yield put(setLoading("voc_after_sales_feedback_comments_filters", true));
    const response: Record<string, any> = yield retry(4, secondsDelay, getVocAfterSalesFeedbackCommentsFilters);
    if (!("error" in response)) {
      yield put(setVocAfterSalesFeedbackCommentsFilters(response));
    }
  } catch (err) {
    console.log("failed to fetch voc-after_sales/categories/feedback-comments-filters");
  } finally {
    yield put(setLoading("voc_after_sales_feedback_comments_filters", false));
  }
}
